module.exports = __webpack_public_path__ + "static/img/06.21ac1ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-mb/story/06.png
// module id = iLz8
// module chunks = 1